// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__TweeR"};